import { faHandshake } from '@fortawesome/free-solid-svg-icons'
import RouterErrorHandler from '@/components/RouterErrorHandler'
import { Roles } from '@/auth/azure/Roles'
import { TileRoleRoute } from '@/types'
import { Commissioni } from '@/routes/admin/autodesk/pages/Commissioni'

export const CommissioniRoute = {
  path: 'commissioni',
  text: 'Commissioni',
  element: <Commissioni />,
  mainMenuRoute: false,
  faIcon: faHandshake,
  errorElement: <RouterErrorHandler />,
  handle: {
    crumb: () => ({
      label: 'Commissioni',
      icon: faHandshake,
    }),
  },
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator, Roles.Administrator],
} satisfies TileRoleRoute
